(function () {
  function initNavigation() {
    var nav = document.querySelector('[data-army-nav]');
    if (!nav || nav.dataset.navigationReady) return;
    nav.dataset.navigationReady = 'true';

    var openBtn = nav.querySelector('[data-mobile-open]');
    var closeBtn = nav.querySelector('[data-mobile-close]');
    var panel = nav.querySelector('[data-mobile-panel]');
    var overlay = nav.querySelector('[data-mobile-overlay]');
    var desktop = window.matchMedia('(min-width: 1200px)');
    var isOpen = false;

    function updateHeight() {
      document.documentElement.style.setProperty('--army-header-height', nav.offsetHeight + 'px');
    }

    function updateScroll() {
      nav.classList.toggle('army-nav--scrolled', window.scrollY > 10);
      updateHeight();
    }

    function setOpen(open, restoreFocus) {
      if (!panel) return;
      isOpen = open;
      nav.classList.toggle('army-nav--menu-open', open);
      panel.inert = !open;
      panel.setAttribute('aria-hidden', String(!open));
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('army-nav-lock', open);
      if (open && closeBtn) closeBtn.focus();
      if (!open && restoreFocus && openBtn) openBtn.focus();
    }

    function onKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false, true);
      }
      if (event.key === 'Tab') {
        var items = Array.from(panel.querySelectorAll('a[href], summary, button:not([disabled]), input:not([disabled]), select, textarea, [tabindex="0"]'))
          .filter(function (item) { return item.getClientRects().length > 0; });
        var first = items[0];
        var last = items[items.length - 1];
        if (!first) return;
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    function onBreakpoint() {
      if (desktop.matches && isOpen) setOpen(false, false);
      updateHeight();
    }

    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false, true); });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false, true); });
    if (panel) panel.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) setOpen(false, false);
    });
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('scroll', updateScroll, { passive: true });
    desktop.addEventListener('change', onBreakpoint);
    var observer = window.ResizeObserver ? new ResizeObserver(updateHeight) : null;
    if (observer) observer.observe(nav);
    updateScroll();
    setOpen(false, false);

    function cleanup(event) {
      if (!event.target.contains(nav)) return;
      setOpen(false, false);
      window.removeEventListener('scroll', updateScroll);
      document.removeEventListener('keydown', onKeydown);
      desktop.removeEventListener('change', onBreakpoint);
      if (observer) observer.disconnect();
      document.removeEventListener('shopify:section:unload', cleanup);
    }
    document.addEventListener('shopify:section:unload', cleanup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavigation);
  } else {
    initNavigation();
  }
  document.addEventListener('shopify:section:load', initNavigation);
})();
